import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Envia um page_view ao Google Analytics em cada troca de rota da SPA.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // pequeno delay para o título da página (react-helmet) já estar atualizado
    const timeout = window.setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 60);
    return () => window.clearTimeout(timeout);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
